<template>
  <PageHeader>
    <template #header-title>{{ $t('Candidates') }}</template>
    <template v-if="!candidatesLoadingError && !loading" #header-actions>
      <AddRecruiterFreelancer
        v-if="user.hasPermission('manage-candidates')"
        :currency="currency"
        :manages-workers="managesWorkers"
      />
    </template>
  </PageHeader>
  <div>
    <div v-if="candidatesLoadingError" class="tw-mt-9">
      <ContentLoadingErrorNotice />
    </div>
    <template v-else>
      <WdsAlert v-if="managesWorkers" info icon class="tw-mb-4">
        {{
          $t(
            'Workers currently engaged in a contractual relationship with you will be subject to the terms and conditions of the existing agreement for the remainder of the contract’s attribution period',
          )
        }}
      </WdsAlert>

      <div>
        <RecruiterFreelancerContacts
          :candidates="result?.recruiterCandidates.data"
          :apollo-loading="loading"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { WdsAlert } from '@worksome/wds-components'
import { useQuery } from '@vue/apollo-composable'
import { computed, ref } from 'vue'
import SilentNetworkError from '@/utils/notification/SilentNetworkError'
import ContentLoadingErrorNotice from '@/components/ContentLoadingErrorNotice.vue'
import AddRecruiterFreelancer from '@/components/Contacts/RecruiterFreelancer/AddRecruiterFreelancer.vue'
import RecruiterFreelancerContacts from '@/components/Contacts/RecruiterFreelancer/RecruiterFreelancerContacts.vue'
import { GetRecruiterCandidatesQuery } from '@/components/Contacts/RecruiterFreelancer/graphql/queries'
import { PER_PAGE_MAXIMUM } from '@/utils/constants'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { user } from '@/composables/useUser'
import PageHeader from '@/components/PageHeader.vue'

defineProps({
  managesWorkers: {
    type: Boolean,
    required: true,
  },
})

const candidatesLoadingError = ref(false)
const currency = computed(() => currentAccount.currency)

const {
  result,
  loading,
  onError: onCandidatesLoadingError,
} = useQuery(
  GetRecruiterCandidatesQuery,
  {
    first: PER_PAGE_MAXIMUM,
  },
  {
    clientId: 'publicApi',
  },
)

onCandidatesLoadingError((error) => {
  candidatesLoadingError.value = true

  new SilentNetworkError({
    ex: error,
  }).dispatch()
})
</script>
